import backgroundSave from "./studio/background_save.js";
import generateContent from "./studio/campaign_content_section/generate_content";
import modal from "./studio/modals.js";
import modalChangeHtmlEditor from "./studio/campaign_content_section/modal_change_html_editor.js";
import modalDownloadContent from "./studio/campaign_content_section/modal_download_content.js";
import customRows from "./studio/campaign_content_section/custom_rows.js";
import modalEditName from "./studio/campaign_content_section/modal_edit_name.js";
import modalEditSubject from "./studio/campaign_content_section/modal_edit_subject.js";
import modalRemoveAttachment from "./studio/campaign_content_section/modal_remove_attachment.js";
import modalUploadAttachment from "./studio/campaign_content_section/modal_upload_attachment.js";
import modalUploadFromFile from "./studio/campaign_content_section/modal_upload_from_file.js";
import modalUploadFromUrl from "./studio/campaign_content_section/modal_upload_from_url.js";
import multiPartContents from "./studio/campaign_content_section/multi_part_contents.js";
import removeContent from "./studio/campaign_content_section/remove_content";
import renderPreviewImage from "./studio/render_preview_image.js";
import screen from "./studio/screens.js";
import screenEditor from "./studio/campaign_content_section/screen_editor.js";
import screenViewRenderedPreview from "./studio/campaign_content_section/screen_view_rendered_preview.js";
import screenViewWebVersion from "./studio/campaign_content_section/screen_view_web_version.js";
import screenViewTextVersion from "./studio/campaign_content_section/screen_view_text_version.js";
import modalInsertForm from "./studio/campaign_content_section/modal_insert_form.js";
import modalInsertCustomField from "./studio/campaign_content_section/modal_insert_custom_field.js";
import modalConvertHtmlToText from "./studio/campaign_content_section/modal_convert_html_to_text.js";
import modalPromptChangeInterface from "./studio/campaign_content_section/modal_prompt_change_interface.js";
import setBeeUID from "./studio/campaign_content_section/set_bee_uid.js";

let reducerList = [
  backgroundSave,
  generateContent,
  modal,
  modalChangeHtmlEditor,
  modalEditName,
  modalEditSubject,
  modalRemoveAttachment,
  modalUploadAttachment,
  modalUploadFromFile,
  modalUploadFromUrl,
  customRows,
  removeContent,
  renderPreviewImage,
  screen,
  screenEditor,
  screenViewRenderedPreview,
  screenViewWebVersion,
  screenViewTextVersion,
  modalDownloadContent,
  multiPartContents,
  modalInsertForm,
  modalInsertCustomField,
  modalConvertHtmlToText,
  modalPromptChangeInterface,
  setBeeUID,
];

export default (state, action) => {
  return reducerList.reduce((s, r) => r(s, action), state);
};
